export default {"src":"/_next/static/media/pair-3.bb8889d0.svg","height":412,"width":524,"blurWidth":0,"blurHeight":0};